/**
 * Cross-screen notification that the customer's address list changed —
 * a different one was made default, or one was added/edited/removed.
 *
 * CustomerHeader and CustomerHome each fetch `/api/customer/addresses`
 * independently (the header for the "Delivery to" chip, Home for its
 * serviceability banner). Without a signal between them, changing the
 * address in one place leaves the other showing the previous one until a
 * full reload — e.g. picking a serviceable address from the header while
 * Home still says "Location Not Serviceable".
 *
 * A window event rather than lifted state or a context: the two components
 * sit on opposite sides of the router outlet, and this matches the
 * `auth:unauthorized` pattern already used in lib/api.js.
 */
export const ADDRESS_CHANGED_EVENT = "customer:address-changed";

/** Announce that the address list (or which one is default) has changed. */
export function notifyAddressChanged() {
  window.dispatchEvent(new CustomEvent(ADDRESS_CHANGED_EVENT));
}

/** Subscribe; returns an unsubscribe function for useEffect cleanup. */
export function onAddressChanged(handler) {
  window.addEventListener(ADDRESS_CHANGED_EVENT, handler);
  return () => window.removeEventListener(ADDRESS_CHANGED_EVENT, handler);
}
